import React from 'react';
import i18n from 'i18next';
import { format, parse } from 'date-fns';
import { addModal, NewItemFormContainer } from '@/exceed';

import getAxiosConfig from './getAxiosConfig';
import getAgendaItemSchema from '../schemas/getAgendaItemSchema';
import handleAgendaItemDataErrors from './handleAgendaItemDataErrors';

export default ({ item, ...rest }, { adminSettings }) => {
  const id = 'edit-agenda-item';

  const model = { ...item?.data, ...rest };

  const parsedTime = parse(`${model.start_date} ${model.start_time}`, 'yyyy-MM-dd HH:mm:ss', new Date());
  const date = format(parsedTime, 'yyyy-MM-dd');
  const time = format(parsedTime, 'h:mmaaa');

  model.start_time = time;
  model.start_date = date;
  model.zoom_account_email = model.content?.zoom_account_email;

  const settingsUrl = model.content?.settings_url;

  return addModal({
    component: (
      <NewItemFormContainer
        getAxiosConfig={(data) => getAxiosConfig('edit-agenda-item', data)}
        id={id}
        isFullScreen
        isSubmitDisabledIfModelUnchanged
        schema={getAgendaItemSchema({ adminSettings, isEditMode: true, settingsUrl })}
        submitText={i18n.t('save')}
        onDataErrors={handleAgendaItemDataErrors}
      />
    ),
    hasCloseButton: true,
    id,
    isFullScreen: true,
    model,
    title: i18n.t('edit-agenda-item'),
  });
};
